<template>
  <button-center
    caption="詳細を設定する"
    :action="setHabitDescription"
  />
</template>

<script>
import ButtonCenter from '@/lib/Button/Center'

export default {
  components: {
    ButtonCenter
  },

  methods: {
    setHabitDescription () {
      this.$router.back()
    }
  }
}
</script>
